import { classNames } from "primereact/utils";
import { useNavigate } from "react-router-dom";
import { AppDialog } from "../../../../../common/components/AppDialog/AppDialog";
import { constructPlannerEventHref } from "../../../../../common/infrastructure/routes/routePaths";
import { DefaultButton } from "../../../../../common/components/button/defaultButton/DefaultButton";
import {
  IfFalse,
  IfTrue,
  RenderWhen,
} from "../../../../../common/infrastructure/components/RenderWhen";
import { IUserModel } from "../models/userModel";
import { useUserDepositDialog } from "../hooks/useUserDepositDialog";
import { UserDepositTransactionDialog } from "./UserDepositTransactionDialog";
import styles from "./UserDepositDialog.module.scss";

interface IUserDepositDialogProps {
  visible: boolean;
  onHide: () => void;
  user?: IUserModel;
}

export const UserDepositDialog = ({
  visible,
  onHide,
  user,
}: IUserDepositDialogProps) => {
  const {
    balanceText,
    balanceTone,
    rows,
    showTransactionDialog,
    transactionMode,
    openTopUpDialog,
    openWithdrawDialog,
    closeTransactionDialog,
  } = useUserDepositDialog({ userId: user?.id, visible });
  const navigate = useNavigate();

  return (
    <AppDialog
      header="Депозити"
      visible={visible}
      className={styles.dialog}
      onHide={onHide}
    >
      <div className={styles.content}>
        <div className={styles.balance_row}>
          <span className={styles.balance_label}>Баланс:</span>
          <span
            className={classNames(
              styles.balance,
              styles[`balance_${balanceTone}`],
            )}
          >
            {balanceText}
          </span>
        </div>

        <p className={styles.notice}>
          Депозитът може да се използва само за плащане на тренировки.
        </p>

        <div className={styles.actions}>
          <DefaultButton
            label="+ Зареди"
            className={styles.topUp_button}
            width="160px"
            onClick={openTopUpDialog}
          />
          <DefaultButton
            label="− Извади"
            className={styles.withdraw_button}
            width="160px"
            onClick={openWithdrawDialog}
          />
        </div>

        <div className={styles.history}>
          <RenderWhen condition={rows.length === 0}>
            <IfTrue>
              <>Няма открити резултати.</>
            </IfTrue>
            <IfFalse>
              {rows.map((row) => {
                // Local const so the click closure keeps the non-null narrowing.
                const eventId = row.eventId;
                const isClickable = eventId !== null;

                return (
                  <div
                    key={row.id}
                    className={classNames(styles.history_row, {
                      [styles.history_row_clickable]: isClickable,
                    })}
                    onClick={
                      isClickable
                        ? () => navigate(constructPlannerEventHref(eventId))
                        : undefined
                    }
                  >
                    <div className={styles.history_row_top}>
                      <span
                        className={classNames(
                          styles.amount,
                          styles[`amount_${row.amountTone}`],
                        )}
                      >
                        {row.amountText}
                      </span>
                      <span className={styles.history_row_date}>
                        {row.dateText}
                      </span>
                    </div>
                    <div className={styles.history_row_comment}>
                      {row.comment}
                    </div>
                    <div className={styles.history_row_author}>
                      {row.createdByName}
                    </div>
                  </div>
                );
              })}
            </IfFalse>
          </RenderWhen>
        </div>
      </div>

      <UserDepositTransactionDialog
        userId={user?.id}
        mode={transactionMode}
        visible={showTransactionDialog}
        onHide={closeTransactionDialog}
      />
    </AppDialog>
  );
};
